import { getDeviceByRadioId } from '@sxm-de/dev-kits/web-sdk/domains/devices';
import { checkIdentityEligibilityAndAutomotiveStatus } from '../helpers/check-identity-eligibility-and-automotive-status';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { normalizeRadioIdForServiceCallWithSupportForUUID } from '@sxm-de/dev-kits/web-sdk/utils';

interface CheckIdentityEligibilityAndVehicleStatusByRadioIdFnPayload {
    radioId: string;
}

export type CheckIdentityEligibilityAndVehicleStatusByRadioIdFn = (
    payload: CheckIdentityEligibilityAndVehicleStatusByRadioIdFnPayload,
) => Promise<void>;

export function initCheckIdentityEligibilityAndVehicleStatusByRadioIdFn({
    dependencies,
}: DomainInitPayload): CheckIdentityEligibilityAndVehicleStatusByRadioIdFn {
    return async ({
        radioId,
    }: CheckIdentityEligibilityAndVehicleStatusByRadioIdFnPayload) => {
        const { appEventSdk } = dependencies;
        let vehicleStateResponse;

        try {
            vehicleStateResponse = await getDeviceByRadioId(
                {
                    radioId:
                        normalizeRadioIdForServiceCallWithSupportForUUID(
                            radioId,
                        ),
                },
                dependencies,
            );

            appEventSdk.trackEvent({
                event: 'device-info',
                deviceInfo: {
                    vid: radioId,
                    year: vehicleStateResponse.vehicleState?.year,
                    make: vehicleStateResponse.vehicleState?.make,
                    model: vehicleStateResponse.vehicleState?.model,
                },
            });
        } catch {
            throw new Error('SYSTEM');
        }

        return checkIdentityEligibilityAndAutomotiveStatus(
            {
                vehicleStateResponse,
            },
            dependencies,
        );
    };
}
